module.exports = {
    appName: 'plgd Dashboard',
    defaultLanguage: 'en',
    supportedLanguages: ['en'],
}
